import Indicator, { IndicatorType } from '../types/Indicator'

const AwesomeOscillator: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'awesomeOscillator',
  label: 'Awesome Oscillator',
  nickname: 'Awesome Oscillator',
  fields: ['awesomeOscillator'],
}

export default AwesomeOscillator
